export default __webpack_public_path__ + "static/media/warning.962f6675.png";